import { render, staticRenderFns } from "./ResultLayoutPopup.vue?vue&type=template&id=ec076186&scoped=true&"
import script from "./ResultLayoutPopup.vue?vue&type=script&lang=js&"
export * from "./ResultLayoutPopup.vue?vue&type=script&lang=js&"
import style0 from "./ResultLayoutPopup.vue?vue&type=style&index=0&id=ec076186&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec076186",
  null
  
)

export default component.exports